import React from 'react';
import { Button, Modal, Text } from '@carnica/ui-kit';
import { cnBem } from '@carnica/utils';
// TODO временно меняем на @beef/ui-kit, т.к. из карники ломает серверный рендеринг
import { useIsMobileDimension } from '@beef/ui-kit';
import styles from "./styles.pcss";
import { getLink } from "./utils";
var cnSwitchAccount = cnBem('switch-account', styles);
export var ChangeAccountModal = function ChangeAccountModal(_ref) {
  var account = _ref.account,
    isOpen = _ref.isOpen,
    setIsOpen = _ref.setIsOpen;
  var isMobile = useIsMobileDimension();
  var switchAccountLink = getLink(account);
  var switchAccount = function switchAccount() {
    if (switchAccountLink) {
      window.location.href = switchAccountLink;
    }
  };
  if (!account) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Modal, {
    className: cnSwitchAccount(null, ['modal']),
    isOpen: isOpen,
    onClose: function onClose() {
      return setIsOpen(false);
    },
    portalClassName: cnSwitchAccount(null, ['portal']),
    "data-t-id": "components-ChangeAccountModal"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cnSwitchAccount(null, ['title'])
  }, /*#__PURE__*/React.createElement(Text, {
    size: isMobile ? 32 : 56
  }, /*#__PURE__*/React.createElement("div", {
    "data-t-id": "components-ChangeAccountModal"
  }, "\u0432\u043E\u0439\u0442\u0438 \u0432 \u043F\u0440\u043E\u0444\u0438\u043B\u044C"), /*#__PURE__*/React.createElement("div", null, account.nickname || account.formattedAccountNumber || account.formattedNumber, "?"))), /*#__PURE__*/React.createElement("div", {
    className: cnSwitchAccount(null, ['description'])
  }, /*#__PURE__*/React.createElement(Text, {
    color: "secondary",
    size: isMobile ? 16 : 24
  }, "\u0441\u043C\u043E\u0436\u0435\u0442\u0435 \u043C\u0435\u043D\u044F\u0442\u044C \u0442\u0430\u0440\u0438\u0444\u044B, \u043D\u0430\u0441\u0442\u0440\u0430\u0438\u0432\u0430\u0442\u044C \u0443\u0441\u043B\u0443\u0433\u0438 \u0438 \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u043E\u043C")), /*#__PURE__*/React.createElement(Button, {
    onClick: switchAccount,
    width: isMobile ? 'full' : 'default'
  }, "\u0432\u043E\u0439\u0442\u0438")));
};